var headroom;
var isHashScrolling = false;

document.addEventListener("DOMContentLoaded", function () {
  var announcement = document.querySelector(".special-announcement-container");
  var closeButton = document.querySelector(".special-announcement-close");
  var header = document.querySelector(".header");
  var resizeTimer;
  var offset = 0;

  function updateAnnouncementOffset() {
    var announcementHeight = 0;
    var headerHeight = header ? header.offsetHeight : 0;

    if (
      announcement &&
      !announcement.classList.contains("is-closed") &&
      !announcement.classList.contains("is-closing")
    ) {
      announcementHeight = announcement.offsetHeight;
    }

    offset = announcementHeight;

    if (header) {
      //header.style.top = announcementHeight + 'px';
    }

    document.documentElement.style.setProperty(
      "--header-total-offset",
      announcementHeight + headerHeight + "px"
    );

    return offset;
  }

  function initHeadroom() {
    if (!header) return;

    updateAnnouncementOffset();

    if (headroom) {
      headroom.destroy();
    }

    headroom = new Headroom(header, {
      offset: offset,
      tolerance: {
        up: 10,
        down: 10,
      },
      // callback when pinned, `this` is headroom object
      onPin: function () {
        if (isHashScrolling) {
          headroom.unpin();
          return;
        }
        jQuery("html").addClass("hr--pinned");
      },
      // callback when unpinned, `this` is headroom object
      onUnpin: function () {
        jQuery("html").removeClass("hr--pinned");
      },
    });

    headroom.init();

    console.log("INIT HEADROOM");
    console.log(headroom);
  }

  initHeadroom();

  window.addEventListener("load", function () {
    initHeadroom();
  });

  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      initHeadroom();
    }, 150);
  });

  if (window.ResizeObserver && announcement) {
    var observer = new ResizeObserver(function () {
      if (
        !announcement.classList.contains("is-closing") &&
        !announcement.classList.contains("is-closed")
      ) {
        initHeadroom();
      }
    });

    observer.observe(announcement);
  }

  if (closeButton && announcement) {
    closeButton.addEventListener("click", function () {
      announcement.classList.add("is-closing");

      window.setTimeout(function () {
        announcement.classList.remove("is-closing");
        announcement.classList.add("is-closed");

        if (header) {
          //header.style.top = '0px';
        }

        // Refresh ScrollTrigger so other animation stuff still works.
        if (window.ScrollTrigger) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              ScrollTrigger.refresh();
            });
          });
        }

        document.documentElement.style.setProperty(
          "--header-total-offset",
          (header ? header.offsetHeight : 0) + "px"
        );

        if (headroom) {
          headroom.destroy();
        }

        headroom = new Headroom(header, {
          offset: 0,
          tolerance: {
            up: 10,
            down: 10,
          },
        });

        headroom.init();
      }, 400);
    });
  }
});


// Scroll pin + crossfade feature
document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap || !window.ScrollTrigger) {
    console.warn("GSAP/ScrollTrigger not loaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var media = document.querySelector(".scroll-block1 .col-first .inner");
  var section2 = document.querySelector(".scroll-block2");
  var header = document.querySelector(".headroom");

  if (!media || !section2) return;

  var img1 = media.querySelector("img.img1");
  var img2 = media.querySelector("img.img2");
  if (!img1 || !img2) return;

  // Ensure initial visibility states
  gsap.set(img1, { autoAlpha: 1 });
  gsap.set(img2, { autoAlpha: 0 });

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function headerH() {
    return header ? header.offsetHeight : 0;
  }

  function docTop(el) {
    var r = el.getBoundingClientRect();
    return r.top + scrollY();
  }

  function calcDistance() {
    var s2Anchor = section2.querySelector(".container-fluid") || section2;

    var mediaH = media.getBoundingClientRect().height;
    var mediaTop = docTop(media);

    var s2Top = docTop(s2Anchor);
    var s2H = section2.getBoundingClientRect().height;

    var targetTop = s2Top + (s2H - mediaH) / 2;
    var dist = targetTop - mediaTop;

    return dist > 0 ? dist : 0;
  }

  // Pin behavior (unchanged)
  ScrollTrigger.create({
    trigger: media,
    start: function () {
      return "top top+=" + headerH();
    },
    end: function () {
      return "+=" + calcDistance();
    },
    pin: media,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
  });

  // Crossfade scrub over same scroll range
  ScrollTrigger.create({
    trigger: media,
    start: function () {
      return "top top+=" + headerH();
    },
    end: function () {
      return "+=" + calcDistance();
    },
    scrub: true,
    invalidateOnRefresh: true,
    onUpdate: function (self) {
      // crossfade centered around halfway
      var center = 0.5;
      var halfWindow = 0.12; // fade spans ~0.38 -> ~0.62
      var t = (self.progress - (center - halfWindow)) / (2 * halfWindow);

      if (t < 0) t = 0;
      if (t > 1) t = 1;

      gsap.set(img1, { autoAlpha: 1 - t });
      gsap.set(img2, { autoAlpha: t });
    },
  });

  function refreshAll() {
    ScrollTrigger.refresh();
  }

  // Refresh after images load (important for correct heights)
  if (!img1.complete) img1.addEventListener("load", refreshAll);
  if (!img2.complete) img2.addEventListener("load", refreshAll);

  window.addEventListener("resize", refreshAll);
  ScrollTrigger.refresh();
});

// Animate projects list page
// Animate FacetWP grid items
document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap) {
    console.warn("GSAP not found");
    return;
  }

  var itemSelector = ".facetwp-template > [class*='col-']";

  function animateFacetwpItems() {
    var items = document.querySelectorAll(itemSelector);
    if (!items || !items.length) return;

    gsap.killTweensOf(items);
    gsap.set(items, { autoAlpha: 0, y: 18 });

    function runAnimation() {
      gsap.to(items, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        stagger: { each: 0.07, from: "start" },
      });
    }

    if (window.imagesLoaded) {
      imagesLoaded(items, function () {
        runAnimation();
      });
    } else {
      runAnimation();
    }
  }

  jQuery(function () {
    animateFacetwpItems();
  });

  jQuery(document).on("facetwp-loaded", function () {
    setTimeout(function () {
      animateFacetwpItems();
    }, 0);
  });
});

// Put this in a global JS file or inline (footer is fine)
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("facetwp-loaded", function () {
    // Close all fSelect dropdowns
    if (typeof fUtil !== "undefined") {
      fUtil(".facetwp-type-fselect .facetwp-dropdown").each(function () {
        // FacetWP attaches the fSelect instance to the dropdown node
        if (this.fselect && typeof this.fselect.close === "function") {
          this.fselect.close();
        }
      });
    } else {
      // Fallback if fUtil isn't available for some reason
      var els = document.querySelectorAll(
        ".facetwp-type-fselect .facetwp-dropdown"
      );
      for (var i = 0; i < els.length; i++) {
        if (els[i].fselect && typeof els[i].fselect.close === "function") {
          els[i].fselect.close();
        }
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  // Target each slider instance
  document
    .querySelectorAll(".projects-client-slider .swiper")
    .forEach(function (swiperEl) {
      var slides = swiperEl.querySelectorAll(".swiper-slide");
      if (!slides.length) return;

      // Set initial state (in case CSS didn't load yet)
      gsap.set(slides, { autoAlpha: 0, y: 16 });

      ScrollTrigger.create({
        trigger: swiperEl,
        start: "top 80%",
        once: true,
        onEnter: function () {
          gsap.to(slides, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            stagger: 0.08,
            clearProps: "transform",
          });
        },
      });
    });
});

// Swiper progress bullet feature.
function restartActiveBulletAnimation(swiper) {
  var bullets = swiper.el.querySelectorAll(".swiper-pagination-bullet");
  if (!bullets.length) return;

  // Remove animation by toggling a class is messy; easiest is reflow trick:
  bullets.forEach(function (b) {
    // remove animation by forcing it to reset
    b.classList.remove("is-animating");
  });

  var active = swiper.el.querySelector(".swiper-pagination-bullet-active");
  if (!active) return;

  // Force reflow then re-add class to restart animation
  // (works even if the same bullet becomes active again)
  void active.offsetWidth;
  active.classList.add("is-animating");
}




jQuery(document).ready(function () {
    const playerGallerySwiperEl = document.querySelector('#swiper_player_gallery');

    if (playerGallerySwiperEl) {
        const playerGallerySwiper = new Swiper(playerGallerySwiperEl, {
            direction: 'horizontal',
            spaceBetween: 24,
            loop: true,
            centeredSlides: false,
            slidesPerView: 1,
            observer: true,
            observeParents: true,
        });
    }
});





jQuery(document).ready(function () {
  (function ($) {
    $(".slider.hover-links").each(function () {
      var slider = this;
      var swiperEl = slider.querySelector(".swiper-container");

      if (!swiperEl || !swiperEl.swiper) {
        return;
      }

      slider.addEventListener("mousemove", function (e) {
        var isClickable = $(e.target).closest(
          "a, button, .swiper-button-prev, .swiper-button-next, .swiper-pagination"
        ).length;

        var rect = slider.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        slider.style.setProperty("--cursor-x", x + "px");
        slider.style.setProperty("--cursor-y", y + "px");

        if (isClickable) {
          slider.classList.remove("hover-left", "hover-right");
          slider.classList.add("hover-link");
          return;
        }

        slider.classList.remove("hover-link");

        var rect = slider.getBoundingClientRect();
        var x = e.clientX - rect.left;

        slider.classList.toggle("hover-left", x < rect.width / 2);
        slider.classList.toggle("hover-right", x >= rect.width / 2);
      });

      slider.addEventListener("mouseleave", function () {
        slider.classList.remove("hover-left", "hover-right", "hover-link");
      });

      slider.addEventListener("click", function (e) {
        if (
          $(e.target).closest(
            "a, button, .swiper-button-prev, .swiper-button-next, .swiper-pagination"
          ).length
        ) {
          return;
        }

        var rect = slider.getBoundingClientRect();
        var x = e.clientX - rect.left;

        if (x < rect.width / 2) {
          swiperEl.swiper.slidePrev();
        } else {
          swiperEl.swiper.slideNext();
        }
      });
    });
  })(jQuery);
});

// Home page animation.
document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".hero-home")) return;

  const heroLogo = document.querySelector("img.hero-logo");

  function startHeroAnimation() {
    gsap.set(".hero-home .hero-logo", {
      y: -40,
      scale: 0.95,
      opacity: 0,
    });

    gsap.set(".hero-home .one-team, .hero-home .one-orange", {
      y: 20,
      opacity: 0,
    });

    gsap.set(".hero-home .lets-go", {
      opacity: 0,
    });

    gsap
      .timeline()
      .to(".hero-home .hero-logo", {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power3.out",
      })
      .to(
        ".hero-home .one-team",
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power3.out",
        },
        "-=.4"
      )
      .to(
        ".hero-home .one-orange",
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power3.out",
        },
        "-=.5"
      )
      .to(
        ".hero-home .lets-go",
        {
          opacity: 1,
          duration: 0.8,
          ease: "power3.out",
        },
        "-=.4"
      );
  }

  function delayedStart() {
    setTimeout(startHeroAnimation, 400); // 0.2 seconds
  }

  if (heroLogo.complete) {
    delayedStart();
  } else {
    heroLogo.addEventListener("load", delayedStart);
  }
});

// Smooth scroll-to
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header.header");
  const hashLinks = document.querySelectorAll('.smooth-scroll a[href^="#"]');

  if (!header) return;

  hashLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = this.getAttribute("href");
      var target = document.querySelector(id);

      if (!target) return;

      e.preventDefault();

      console.log(headroom);
      isHashScrolling = true;

      headroom.unpin();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      var timeout;

      var handleScroll = function () {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
          window.removeEventListener("scroll", handleScroll);
          //headroom.unpin();
          //headroom.unfreeze();
          isHashScrolling = false;
        }, 150);
      };

      window.addEventListener("scroll", handleScroll);
    });
  });
});


jQuery(document).ready(function () {
  console.log('starting gallery');
  jQuery(function ($) {
    $('section[data-featherlight-gallery]').featherlightGallery({
      filter: 'a.gallery',
      previousIcon: '‹',
      nextIcon: '›'
    });
  });
});
